import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  Popconfirm,
  message,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { purchaseOrderService } from "_services";
import PropTypes from "prop-types";
import { CloseOutlined, ShoppingOutlined } from "@ant-design/icons";
import PurchaseOrderSearch from "./Search";

const List = ({ match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    getPurchaseOrders(pageNumber, pageSize);
  }, []);

  const getPurchaseOrders = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setLoading(true);
    purchaseOrderService
      .search(`${searchParams}${paginationParams}`)
      // .getAll(pageNumber)
      .then((data) => {
        setItems(data.content);
        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(pageNumber);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <>
        <Link to={`${path}/add`} key="btn-add">
          <Button>Add PO</Button>
        </Link>
        <Link to={`${path}/customer-order-add`} key="btn-co-add">
          <Button>Customer PO</Button>
        </Link>
      </>
    );
    return buttons;
  };

  const handlePaginateChange = (pageNumber, pageSize) => {
    getPurchaseOrders(pageNumber, pageSize);
  };

  const handleDelete = (id) => {
    purchaseOrderService
      .deletePurchaseOrder(id)
      .then((x) => {
        message.success("Successfully deleted!");
        getPurchaseOrders(pageNumber);
      })
      .catch((error) => {
        setError(error);
      });
  };

  const columns = [
    {
      title: "Order No",
      dataIndex: "orderNumber",
      key: "orderNumber",
      render: (text, record) => (
        <Link to={`/purchase-orders/${record.id}/summary`}>{text}</Link>
      ),
    },
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      render: (text, record) => record.orderDate ?? "",
    },
    {
      title: "Expected Date",
      dataIndex: "expectedDate",
      key: "expectedDate",
      render: (text, record) => record.expectedDate ?? "",
    },
    {
      title: "Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      render: (text, record) => {
        let color = "";
        if (record.orderStatus?.code === "POSCOM") {
          color = "#87d068";
        }
        if (record.orderStatus?.code === "POSCL") {
          color = "#87d068";
        }
        if (record.orderStatus?.code === "POSOP") {
          color = "#2db7f5";
        }
        if (record.orderStatus?.code === "POSDEC") {
          color = "#108ee9";
        }
        if (record.orderStatus?.code === "POSAA") {
          color = "#108ee9";
        }
        return <Tag color={color}>{record.orderStatus?.name}</Tag>;
      },
    },
    {
      title: "Store Code",
      dataIndex: "store",
      key: "store",
      render: (text, record) => record.store?.code ?? "",
    },
    {
      title: "Supplier Name",
      dataIndex: "supplier",
      key: "supplier",
      render: (text, record) => record.supplier?.name ?? "",
    },
    {
      title: "Type",
      dataIndex: "purchaseOrderType",
      key: "purchaseOrderType",
      render: (text, record) => record.purchaseOrderType?.name,
    },
    {
      title: "Total",
      key: "totalPrice",
      render: (text, record) => <span></span>,
    },
    {
      title: "Days O/S",
      key: "outstandingDays",
      render: (text, record) => <span></span>,
    },
    {
      title: "Action",
      key: "action",
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Are you sure to delete this item?"
          onConfirm={() => {
            handleDelete(record.id);
          }}
        >
          <CloseOutlined />
        </Popconfirm>
      ),
    },
    {
      title: "Stock Receipt",
      key: "action",
      width: "5%",
      render: (text, record) => (
        <Link to={`/stock-receipts/upload`}>
          <ShoppingOutlined style={{ fontSize: 18, cursor: "pointer" }} />
        </Link>
      ),
    }
    
  ];

  const handleSearchResults = (results, totalRecords, searchParams) => {
    setItems(results);
    setTotalRecords(totalRecords);
    setSearchParams(searchParams);
    setPageNumber(1);
    setLoading(false);
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/purchase-orders">Purchase Orders Search</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          {/* {Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"]) && ( */}
          <PurchaseOrderSearch
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
          />
          {/* )} */}
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={items}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: handlePaginateChange,
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

List.propTypes = {
  match: PropTypes.isRequired,
};

export default List;
